import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

// Connects to data-controller="admin-track-numbers"
export default class extends Controller {
  static targets = ['list', 'item', 'trackNumber']

  connect() {
    Sortable.create(this.listTarget, {
      animation: 200,
      onEnd: this.refreshOrder.bind(this)
    })
  }

  refreshOrder() {
    this.trackNumberTargets.forEach((trackNumber, index) => {
      trackNumber.textContent = index + 1
    })
  }
}
